var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common-style-config" },
    [
      _c(
        "el-collapse",
        [
          _c(
            "el-form",
            {
              attrs: {
                size: "mini",
                "label-position": "top",
                model: _vm.selectItem.styleConfig,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-collapse-item",
                { attrs: { title: "标题与卡片" } },
                [
                  _c(
                    "style-sub-item",
                    { attrs: { title: "标题" } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value:
                                  _vm.selectItem.styleConfig.commongConfig
                                    .showTitle,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.selectItem.styleConfig.commongConfig,
                                    "showTitle",
                                    $$v
                                  )
                                },
                                expression:
                                  "selectItem.styleConfig.commongConfig.showTitle",
                              },
                            },
                            [_vm._v("显示主标题")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "chart-form-item-warp" },
                            [
                              _c(
                                "span",
                                { staticClass: "jz-chart-title-label" },
                                [_vm._v("标题")]
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                model: {
                                  value: _vm.selectItem.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selectItem, "name", $$v)
                                  },
                                  expression: "selectItem.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "style-sub-item",
                    { attrs: { title: "备注" } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value:
                                  _vm.selectItem.styleConfig.commongConfig
                                    .showRemark,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.selectItem.styleConfig.commongConfig,
                                    "showRemark",
                                    $$v
                                  )
                                },
                                expression:
                                  "selectItem.styleConfig.commongConfig.showRemark",
                              },
                            },
                            [_vm._v("显示备注")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "chart-form-item-warp" },
                            [
                              _c(
                                "span",
                                { staticClass: "jz-chart-title-label" },
                                [_vm._v("备注")]
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.selectItem.styleConfig.commongConfig
                                      .remark,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selectItem.styleConfig.commongConfig,
                                      "remark",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "selectItem.styleConfig.commongConfig.remark",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "chart-form-item-warp" },
                            [
                              _c(
                                "span",
                                { staticClass: "jz-chart-title-label" },
                                [_vm._v("位置")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value:
                                      _vm.selectItem.styleConfig.commongConfig
                                        .remarkPosition,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectItem.styleConfig
                                          .commongConfig,
                                        "remarkPosition",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selectItem.styleConfig.commongConfig.remarkPosition",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        label: _vm.remarkPositionMap.title,
                                      },
                                    },
                                    [_vm._v("紧跟标题")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        label: _vm.remarkPositionMap.top,
                                      },
                                    },
                                    [_vm._v("图表上方")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "style-sub-item",
                    { attrs: { title: "组件容器" } },
                    [
                      _c("el-form-item", [
                        _c(
                          "div",
                          { staticClass: "chart-form-item-warp" },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                model: {
                                  value:
                                    _vm.selectItem.styleConfig.commongConfig
                                      .customBackgroundColor,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selectItem.styleConfig.commongConfig,
                                      "customBackgroundColor",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "selectItem.styleConfig.commongConfig.customBackgroundColor",
                                },
                              },
                              [_vm._v("自定义背景填充")]
                            ),
                            _vm._v(" "),
                            _c("el-color-picker", {
                              attrs: { "show-alpha": "" },
                              model: {
                                value:
                                  _vm.selectItem.styleConfig.commongConfig
                                    .backgroundColor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.selectItem.styleConfig.commongConfig,
                                    "backgroundColor",
                                    $$v
                                  )
                                },
                                expression:
                                  "selectItem.styleConfig.commongConfig.backgroundColor",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(_vm.selectItem.styleComp.type, {
                tag: "component",
                attrs: { selectItem: _vm.selectItem },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }